module.exports = __webpack_public_path__ + "img/hospital.56dd3740.png";